import React, { useEffect, useState } from "react";
import { Plus, Trash2, Edit2 } from "lucide-react";
import api from "../../lib/api";

export default function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [form, setForm] = useState({ email: "", password: "", name: "", role: "marker" });
    const [editing, setEditing] = useState(null);

    const load = () => api.get("/users").then(r => setUsers(r.data));
    useEffect(() => { load(); }, []);

    const save = async (e) => {
        e.preventDefault();
        if (editing) {
            await api.put(`/users/${editing}`, { name: form.name, role: form.role, password: form.password || undefined });
        } else {
            await api.post("/users", form);
        }
        setForm({ email: "", password: "", name: "", role: "marker" });
        setEditing(null);
        load();
    };

    const del = async (id) => {
        if (!window.confirm("Supprimer cet utilisateur ?")) return;
        await api.delete(`/users/${id}`);
        load();
    };

    return (
        <div data-testid="admin-users">
            <h1 className="font-display text-4xl uppercase tracking-widest mb-6">Utilisateurs</h1>
            <form onSubmit={save} className="glass-card p-5 grid sm:grid-cols-5 gap-3 mb-6">
                <input className="input-field" placeholder="Courriel" required type="email" disabled={!!editing} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email" />
                <input className="input-field" placeholder="Nom" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name" />
                <input className="input-field" placeholder={editing ? "Nouveau mot de passe (optionnel)" : "Mot de passe"} type="password" required={!editing} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="user-password" />
                <select className="input-field" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role">
                    <option value="admin">admin</option>
                    <option value="marker">marker</option>
                </select>
                <button className="btn-primary justify-center" type="submit" data-testid="user-save"><Plus size={14} /> {editing ? "Modifier" : "Ajouter"}</button>
            </form>
            {/* Mobile cards */}
            <div className="lg:hidden grid gap-3">
                {users.map(u => (
                    <div key={u.id} className="glass-card p-4" data-testid={`user-card-${u.id}`}>
                        <div className="flex items-start justify-between gap-3 mb-2">
                            <div className="min-w-0 flex-1">
                                <div className="font-display text-lg uppercase truncate">{u.name}</div>
                                <div className="text-xs text-white/60 break-all">{u.email}</div>
                            </div>
                            <span className={`px-2 py-1 angle-tag text-[10px] font-bold shrink-0 ${u.role === "admin" ? "bg-[#7FD93C]/20 text-[#7FD93C]" : "bg-[#4FE0D5]/20 text-[#4FE0D5]"}`}>{u.role}</span>
                        </div>
                        <div className="flex gap-2 mt-3 pt-3 border-t border-white/10">
                            <button onClick={() => { setEditing(u.id); setForm({ email: u.email, password: "", name: u.name, role: u.role }); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="btn-ghost flex-1 justify-center"><Edit2 size={12} /> Modifier</button>
                            <button onClick={() => del(u.id)} className="btn-ghost flex-1 justify-center text-rose-400 border-rose-400/30 hover:border-rose-400" data-testid={`user-delete-${u.id}`}><Trash2 size={12} /> Supprimer</button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Desktop table */}
            <div className="hidden lg:block overflow-x-auto"><table className="tx-table">
                <thead><tr><th>Email</th><th>Nom</th><th>Rôle</th><th></th></tr></thead>
                <tbody>{users.map(u => (
                    <tr key={u.id}>
                        <td>{u.email}</td>
                        <td>{u.name}</td>
                        <td><span className={`px-2 py-1 angle-tag text-xs font-bold ${u.role === "admin" ? "bg-[#7FD93C]/20 text-[#7FD93C]" : "bg-[#4FE0D5]/20 text-[#4FE0D5]"}`}>{u.role}</span></td>
                        <td className="text-right"><div className="flex justify-end gap-2">
                            <button onClick={() => { setEditing(u.id); setForm({ email: u.email, password: "", name: u.name, role: u.role }); }} className="btn-ghost"><Edit2 size={12} /></button>
                            <button onClick={() => del(u.id)} className="btn-ghost text-rose-400 border-rose-400/30 hover:border-rose-400" data-testid={`user-delete-${u.id}`}><Trash2 size={12} /></button>
                        </div></td>
                    </tr>
                ))}</tbody>
            </table></div>
        </div>
    );
}
